import { takeLatest, all, call, put } from 'redux-saga/effects';
import axios from 'axios';
import { errorlog } from '../helpers/ErrorLogService';
import {payPaymentDue} from '../helpers/PaymentDueHelper';
import config from '../config/app.json';
import { get } from 'https';
import {OrderedMap} from 'immutable';
import uuid from 'uuid/v1';

var csrftoken = getCookie('csrftoken');
var encodetoken = getCookie("encoded_token")
const environment = config["APIURIS"]["current"];

function fetchUserDetails(data) {
  const params = new URLSearchParams();
  params.append('projectId', data.projectId);
  params.append('userId', data.userId);
  params.append('teamId', data.teamId);
  return axios({
    method: 'post',
    url: config["APIURIS"][environment] + 'app/usr/slides/d/',
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}

function fetchEffects(data) {
  const params = new URLSearchParams();
  let url = config["APIURIS"][environment] + 'deck/eff';

  params.append('id', `transitioneffects_${data.lang}`);
  return axios({
    method: 'post',
    url: url,
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}

function fetchAutoSearch(data) {
  
  const params = new URLSearchParams();
  params.append('type', "ACTION");
  params.append('u', data.data.userId);

  let url = config["APIURIS"][environment] + 'app/sgs';
  return axios({
    method: 'post',
    url: url,
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}

function getColorThemes(data){
  let params = new URLSearchParams();
  params.append('bf', data.hasBrand);
  params.append('t', data.data.teamId);
  params.append('u', data.data.userId);
  let url = config["APIURIS"][environment] + 'deck/eff';

  params.append('id', `colorthemes_${data.data.lang}`);
  return axios({
    method: 'post',
    url: url,
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}

function fetchShareDetails(data){
  const params = new URLSearchParams();
  let url = config["APIURIS"][environment] + 'share/shareDetails/';

  params.append("userId", data.userId);
  params.append("projectId", data.projectId);
  return axios({
    method: 'post',
    url: url,
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}


function fetchMaster(gitLib) {
  const params = new URLSearchParams();
  let url = config["APIURIS"][environment] + 'library/masterdata/',
    libData = gitLib.libData,
    libType = libData.type;

  if (libType === 'VIDEO' || libType === 'AUDIO' || libType === 'IMG') {
    url = config["APIURIS"][environment] + 'app/f/guploads';
    params.append('type', libType);
    params.append('userid', libData.userId);
    params.append('from', libData.from);
    params.append('size', libData.size);
  } else {
    params.append('id', libType.toLowerCase());
  }
  return axios({
    method: 'post',
    url: url,
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}

function fetchTransition(data) {

  const params = new URLSearchParams();
  let url = config["APIURIS"][environment] + 'deck/eff';

  params.append('id', `scenetransitions_${data.lang}`);
  return axios({
    method: 'post',
    url: url,
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });

}

function fetchUserFonts(data) {

  const params = new URLSearchParams();
  params.append('userId', data.userId);
  params.append('t', data.teamId);
  params.append('bf', data.bf);
  
  return axios({
    method: 'post',
    url: config["APIURIS"][environment] + 'getFontFiles',
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}



function postFolder(getLib) {
  const params = new URLSearchParams();
  params.append('name', getLib.folder);
  params.append('parent', getLib.parent);
  params.append('userId', getLib.userId);
  params.append('u', getLib.userId);
  params.append('teamId', getLib.teamId);
  return axios({
    method: 'post',
    url: config["APIURIS"][environment] + 'app/f/cf',
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}

function deleteFilesContent(getlib) {
  const params = new URLSearchParams();
  params.append('id', getlib.id);
  params.append('u', getlib.userId);
  return axios({
    method: 'post',
    url: config["APIURIS"][environment] + 'app/f/df',
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}

function fetchCategory(getLib) {
  
  const params = new URLSearchParams();
  let url = config["APIURIS"][environment] + 'app/gll/';
  params.append('u', getLib.userId);
  params.append('teamId', getLib.teamId);
  params.append('projectId', getLib.projectId);

  if(getLib.type.includes('MAS') && (!getLib.type.includes('MASSCENEPRE') || (getLib.type.includes('MASSCENEPRE') && !getLib.propCategoryEnded))){
    url = config["APIURIS"][environment] + 'deck/mst/';
    if(getLib.type.includes('MASSCENEPRE')){
      params.append('app','deck')
    }
  }
  if (getLib.type === "SHAPE") {
    params.append('subType', "CSTMPTH");
    params.append('isActive', 1);
  }

  if(getLib.type === 'PROP' && getLib.subType === 'EPROP'){
    params.append('subType', getLib.subType);
  }

  if(getLib.type === 'PROP'){
    
    if(getLib.subType === 'EPROP'){
      params.append('type', 'PROP');
    }else{
      params.append('type', 'PROP,SHAPE');
    }
  }else if(getLib.type === 'PREBUILT'){
    params.append('type', 'SCENEPRE');
  }else{
    params.append('type', getLib.type);
  }

  params.append('projectSize', getLib.projectSize);
  if(getLib.propCategoryEnded || getLib.type === 'TEXT'){
    url = config["APIURIS"][environment] + 'deck/fprop/'
  }

  if(getLib.type === 'MASGIPHY' || getLib.type === 'GIPHY'){
    url = config["APIURIS"][environment]+'app/gif/gd';
  }

  if(getLib.type === 'STOCKIMG'){
    url = config["APIURIS"][environment]+'app/sicol';
    params.append('exclusive', getLib.exclusive);
  }

  if(getLib.type === 'STOCKVID'){
    url = config['APIURIS'][environment]+'app/svcol';
    params.append('exclusive', getLib.exclusive);
  }
  

  if (getLib.type === "TEXT") {
    params.append('isActive', 1);
  }
  if(getLib.type !== 'STOCKIMG' && getLib.type !== 'STOCKVID' && getLib.type !== 'GIPHY')
    params.append('categories', getLib.categories);
  
  params.append('from', getLib.from);
  params.append('size', getLib.size);
  if (getLib.fromSearch || getLib.type === 'STOCKIMG' || getLib.type === 'STOCKVID' || getLib.type === 'GIPHY'){
    let tagValue = (getLib.fromSearch) ? getLib.tags : (getLib.categories === 'Top Exclusive' || getLib.categories === 'All Items') ? '' : getLib.categories;
    if((getLib.type === 'STOCKIMG' || getLib.type === 'STOCKVID' || getLib.type === 'GIPHY') && getLib.searchtag){
      tagValue = getLib.searchtag;
    }
    params.append('tags', tagValue)
  }

  if (getLib.excludes !== undefined)
    params.append('excludes', getLib.excludes);
  if(getLib.hasBrand){
    params.append('bf', getLib.hasBrand);
  }
  return axios({
    method: 'post',
    url: url,
    mode: 'cors',
    withCredentials: false,
    credentials: 'same-origin',
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    xsrfHeaderName: "X-CSRFToken",
    data: params
  });
}

function getCookie(name) {
  var cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

function fetchUpload(getLib, roottype) {
  const params = new URLSearchParams();
  params.append('roottype', roottype);
  params.append('parent', getLib.parent);
  params.append('u', getLib.userId);
  params.append('t', getLib.teamId);
  params.append('bf', getLib.bf);
  if (roottype === "folder") {
    params.append('from', 0);
    params.append('size', 100);
    params.append('userId', getLib.userId);
  }
  else {
    params.append('from', getLib.from);
    params.append('size', getLib.size);
    params.append('userId', getLib.userId);
  }
  return axios({
    method: 'post',
    url: config["APIURIS"][environment] + 'deck/f/gf',
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}

function moveUserFolder(getLib) {
  const params = new URLSearchParams();
  params.append('selectedobjects', [getLib.id]);
  params.append('parent', getLib.parent);
  params.append('u', getLib.userId);

  return axios({
    method: 'post',
    url: config["APIURIS"][environment] + 'app/f/mf',
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}

function renameUserFolder(getLib) {
  const params = new URLSearchParams();
  params.append('id', getLib.id);
  params.append('name', getLib.name);
  params.append('u', getLib.userId);
  return axios({
    method: 'post',
    url: config["APIURIS"][environment] + 'app/f/rf',
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}

function fetchActionData(getLib) {
  const params = new URLSearchParams();
  params.append('genderType', getLib.gender);
  params.append('from', getLib.from);
  params.append('size', getLib.size);
  params.append('u', getLib.userId);
  params.append('t', getLib.teamId);
  params.append('type', getLib.actionToLoad);

  return axios({
    method: 'post',
    url: config["APIURIS"][environment] + 'app/gact',
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}

function fetchSearchData(getLib) {
  const params = new URLSearchParams();
  params.append('tags', getLib.tags);
  params.append('from', getLib.from);
  params.append('size', getLib.size);
  params.append('fromScroll', getLib.fromScroll);
  params.append('action', getLib.action);
  params.append('priority', getLib.priority);
  params.append('userId', getLib.userId);
  params.append('u', getLib.userId);
  params.append('teamId', getLib.teamId);
  params.append('projectSize', getLib.projectSize);
  params.append('projectId', getLib.projectId);

  if(getLib.type === 'PROP'){
    params.append('type', 'PROP,SHAPE');
  }else{
    params.append('type', getLib.type);
  }

  if(getLib.type === "ACTION")
    params.append('genderType', getLib.genderType);

  return axios({
    method: 'post',
    url: config["APIURIS"][environment] + 'app/soak',
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}

function fetchGiphyData(getLib){
  const params = new URLSearchParams();
  params.append('tags', getLib.tags);
  params.append('from', getLib.from);
  params.append('size', getLib.size);
  params.append('action', getLib.action);
  params.append('priority', getLib.priority);
  params.append('userId', getLib.userId);
  params.append('u', getLib.userId);
  params.append('teamId', getLib.teamId);
  params.append('type', 'GIPHY');

  return axios({
    method: 'post',
    url: config["APIURIS"][environment] + 'app/gif/s',
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}

function fetchStockImgData(getLib){
  const params = new URLSearchParams();
  params.append('tags', getLib.tags);
  params.append('from', getLib.from);
  params.append('size', getLib.size);
  params.append('action', getLib.action);
  params.append('priority', getLib.priority);
  params.append('userId', getLib.userId);
  params.append('u', getLib.userId);
  params.append('teamId', getLib.teamId);
  params.append('type', 'STOCKIMG');
  params.append('exclusive', getLib.exclusive);
  params.append('projectId', getLib.projectId);
  if(getLib.fromSearch){
    params.append('fromSearch', getLib.fromSearch);
  }

  return axios({
    method: 'post',
    url: config["APIURIS"][environment] + 'app/sicol',
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}

function fetchStockVideos(getLib){
  const params = new URLSearchParams();
  params.append('tags', getLib.tags);
  params.append('from', getLib.from);
  params.append('size', getLib.size);
  params.append('action', getLib.action);
  params.append('priority', getLib.priority);
  params.append('userId', getLib.userId);
  params.append('u', getLib.userId);
  params.append('teamId', getLib.teamId);
  params.append('type', getLib.type);
  params.append('exclusive', getLib.exclusive);
  params.append('projectId', getLib.projectId);
  if (getLib.excludes !== undefined)
    params.append('excludes', getLib.excludes);
  if(getLib.isScroll)
    params.append('fromScroll', getLib.isScroll);
  else
    params.append('fromScroll', false);

  if(getLib.fromSearch){
    params.append('fromSearch', getLib.fromSearch);
  }
  return axios({
    method: 'post',
    url: config["APIURIS"][environment] + 'app/svcol',
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}

function fetchStockSearchData(getLib) {
  const params = new URLSearchParams();
  params.append('tags', getLib.tags);
  params.append('type', getLib.type);
  params.append('from', getLib.from);
  params.append('size', getLib.size);
  params.append('fromScroll', getLib.fromScroll);
  params.append('userId', getLib.userId);
  params.append('u', getLib.userId);
  params.append('teamId', getLib.teamId);

  return axios({
    method: 'post',
    url: config["APIURIS"][environment] + 'SearchStock',
    headers: {  "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  });
}

function exportProject(postState) {
  
  let exportUrl = config["APIURIS"][environment] + "dashboard/download_upload";

  const params = new URLSearchParams();
  for (var key in postState) {
    params.append(key, postState[key]);
  }

  return axios({
    method: 'post',
    url: exportUrl,
    headers: { "Content-Type": "application/x-www-form-urlencoded", "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  }).then(function (response) {
    return response;
  }).catch(function (error) {
    return 'error';
  });
}

export function* onExportProject(getData) {
  if (getData.isClicked) {
    const postState = getData.state;
    try {
      const response = yield call(exportProject, postState);
     
      if(response.data.success === true){
        yield put({ type: 'MANAGE_TOAST', data : {action : "add", type : "success", "message" : "ex.suc", formatId: 'msg'}});
      }
      else if(response.data.error !== undefined && response.data.error !== ""){
        yield put({ type: 'MANAGE_TOAST', data : {action : "add", type : "error", "message" : response.data.error}});
      }
      else if(response === "error"){
        yield put({ type: 'MANAGE_TOAST', data : {action : "add", type : "error", "message" : "common.toast.msg", link : config["APIURIS"][environment], linkName : "Marketing Video", formatId: 'msg'}});
      }
    } catch (error) {
      yield put({ type: 'MANAGE_TOAST', data : {action : "add", type : "error", "message" : "common.toast.msg", formatId: 'msg'}});
    }
  }
}

function shareProject(postState) {
  
  const params = new URLSearchParams();
  for (var key in postState.data) {
    params.append(key, postState.data[key]);
  }

  return axios({
    method: 'post',
    url: config["APIURIS"][environment] + "deckshare",
    headers: { "Content-Type": "application/x-www-form-urlencoded", "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  }).then(function (response) {
    return response;
  }).catch(function (error) {
    return 'error';
  });
}

export function* onShareProject(getData) {
    try {
      const response = yield call(shareProject, getData);
     
      if(response.data.shared === true){
        var shareDetails = yield call(fetchShareDetails, {projectId : getData.data.projectid, userId : getData.data.userId});
        yield put({ type: "SET_SHARE_DETAILS", data: shareDetails.data });
        yield put({ type: 'MANAGE_TOAST', data : {action : "add", type : "success", "message" : "sh.su.w", formatId: "msg", lVal:response.data.sharedWith.length +" "+ (response.data.sharedWith.length === 1?"person":"people")}});
      }
      else if(response.data.error !== undefined && response.data.error){
        yield put({ type: 'MANAGE_TOAST', data : {action : "add", type : "error", "message" : response.data.message}});
      }
      else if(response === "error"){
        yield put({ type: 'MANAGE_TOAST', data : {action : "add", type : "error", "message" : "common.toast.msg", formatId: 'msg'}});
      }

      if(response.data.sharedError){
        yield put({ type: 'MANAGE_TOAST', data : {action : "add", type : "error", "message" : response.data.alreadyShared.length + " email(s) already shared"}});
      }
      if(response.data.emailError){
        yield put({ type: 'MANAGE_TOAST', data : {action : "add", type : "error", "message" : "mt.inv.eml", formatId: 'msg'}});
      }
      
    } catch (error) {
      yield put({ type: 'MANAGE_TOAST', data : {action : "add", type : "error", "message" : "common.toast.msg", formatId: 'msg'}});
    }
}



/* To Resize project */
function projectResize(postState) {
  let exportUrl = config["APIURIS"][environment] + "share/createproject/";
  const params = new URLSearchParams();
  params.append('type', postState.data.type === "vertical"?"ver":postState.data.type === "horizontal"?"hor":"sqr");
  params.append('userId', postState.data.userId);
  params.append('teamId', postState.data.teamId);
  params.append('projectId', postState.data.projectId);
  params.append('projectWidth', postState.data.projectData.width);
  params.append('projectHeight', postState.data.projectData.height);
  params.append('projectDuration', postState.data.projectData.duration);
  params.append('appMode', postState.data.appMode);
  params.append('projectData', JSON.stringify(postState.data.projectData));
  
  document.getElementById("app-overlay").style.display = "block";
  document.getElementById("app-overlay").style.zIndex = "2000";
  document.getElementById("app-overlay").style.backgroundColor = "rgba(0,0,0,0.5)";
  document.getElementById("app-overlay").style.backgroundImage = "url("+config["APPICONS"][config["APPICONS"]["current"]]+"/images/chr-loading.svg)";
  document.getElementById("app-overlay").style.backgroundPosition = "center";
  document.getElementById("app-overlay").style.backgroundRepeat = "no-repeat";
  document.getElementById("app-overlay").className = "overlayDom-tool-bar";
  const newWindow = window.open();
  return axios({
    method: 'post',
    url: exportUrl,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  }).then(function (response) {
    document.getElementById("app-overlay").className = "";
    document.getElementById("app-overlay").style.display = "none";
    document.getElementById("app-overlay").style.zIndex = "9";
    document.getElementById("app-overlay").style.backgroundColor = "transparent";
    document.getElementById("app-overlay").style.background = "none";
    if (response.status === 200) {
      newWindow.location = config["APIURIS"][environment] + "slides" +'/' + response.data.projectid + '/';
      return 'export done';
    } else {
      return 'export failed';
    }
  }).catch(function (error) {
    errorlog(error, error.message, "Saga-projectResize");
    newWindow.close();
    document.getElementById("app-overlay").className = "";
    document.getElementById("app-overlay").style.display = "none";
    document.getElementById("app-overlay").style.zIndex = "9";
    document.getElementById("app-overlay").style.backgroundColor = "transparent";
    document.getElementById("app-overlay").style.background = "none";
    return 'error';
  });
}

export function* onProjectResize(data) {
  try {
    const response = yield call(projectResize, data);
  } catch (e) {
    errorlog("Error on project resize....!", e, "Saga-onProjectResize");
  }
}

function duplicateProject(postState) {
  let exportUrl = config["APIURIS"][environment] + "moments/duplicateProject/";
  const params = new URLSearchParams();
  params.append("projectId", postState.data.projectId);
  params.append('userId', postState.data.userId);
  params.append('teamId', postState.data.teamId);

  document.getElementById("app-overlay").style.display = "block";
  document.getElementById("app-overlay").style.zIndex = "2000";
  document.getElementById("app-overlay").style.backgroundColor = "rgba(0,0,0,0.5)";
  document.getElementById("app-overlay").style.backgroundImage = "url("+config["APPICONS"][config["APPICONS"]["current"]]+"/images/chr-loading.svg)";
  document.getElementById("app-overlay").style.backgroundPosition = "center";
  document.getElementById("app-overlay").style.backgroundRepeat = "no-repeat";
  document.getElementById("app-overlay").className = "overlayDom-tool-bar";
  const newWindow = window.open();
  return axios({
    method: 'post',
    url: exportUrl,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data: params
  }).then(function (response) {
    newWindow.location = config["APIURIS"][environment] + "slides" +'/' + response.data.projectId + '/';
    document.getElementById("app-overlay").className = "";
    document.getElementById("app-overlay").style.display = "none";
    document.getElementById("app-overlay").style.zIndex = "9";
    document.getElementById("app-overlay").style.backgroundColor = "transparent";
    document.getElementById("app-overlay").style.background = "none";

    return response;
  }).catch(function (error) {
    newWindow.close();
    document.getElementById("app-overlay").className = "";
    document.getElementById("app-overlay").style.display = "none";
    document.getElementById("app-overlay").style.zIndex = "9";
    document.getElementById("app-overlay").style.backgroundColor = "transparent";
    document.getElementById("app-overlay").style.background = "none";
    return 'error';
  });
}

export function* onProjectDuplicate(data) {
  try {
    const response = yield call(duplicateProject, data);
    if(!response.data.error){
      yield put({ type: 'MANAGE_TOAST', data : {action : "add", type : "success", "message" : "dup.suc", formatId: 'msg'}});
    }else{
      if(response.data.data.pastdue) {
        payPaymentDue(data.data.propsToDispatch,data.data.teamId,'duplicate',data.data.socket,'deckupgrade','duplicate')
      } else {
        yield put({ type: 'MANAGE_TOAST', data : {action : "add", type : "error", "message" : response.data.message}});
      }
    }
    
  } catch (e) {
    yield put({ type: 'MANAGE_TOAST', data : {action : "add", type : "error", "message" : "common.toast.msg", formatId: 'msg'}});
  }
}

/* End Heres */

export function* createLibraryFolder(getLib) {
  try{
    var response = yield call(postFolder, getLib.libData);
    if (getLib.libData.isAddLibrary)
      yield put({ type: 'CREATE_FOLDER_COMPLETE', data: response.data });
  }catch(err){
    errorlog(getLib.libData + " failed while creating folder ", err, "Saga-createLibraryFolder");
    yield put({ type: 'MANAGE_TOAST', data : {action : "add", type : "error", "message" : "err.c.f", formatId: 'msg'}});
  }
}

export function* deleteFiles(id, userId) {
  var response = yield call(deleteFilesContent, id, userId)
}

export function* loadMasterLibrary(getLib) {
  try {
    var response = '',  type = getLib.libData.type;
      response = yield call(fetchMaster, getLib)
 
    if (getLib.libData.type === 'VIDEO') {
      type = 'UPVIDEO'
    }else if(getLib.libData.type === 'IMG'){
      type = 'UPIMAGE'
    }
    if(!response.data.length){
      yield put({ type: 'RESP_UPDATE', data: {
          status : 'failed',
        }
      })
    }
    yield put({ type: 'LOAD_MASTER_LIBRARY_COMPLETE', data: response.data, libType: type });
  } catch (error) {
    errorlog(getLib.libData + " load library failed loadMasterLibrary" ,error, "Saga-loadMasterLibrary");
  }
}

export function* loadLibraryUpload(getLib) {
  try {
    var responseFolder = yield call(fetchUpload, getLib.libData, "folder")
    var libraries = OrderedMap();
    if (responseFolder.data.success) {
      for (let i = 0; i < responseFolder.data.assets.length; i++) {
        libraries = libraries.set(responseFolder.data.assets[i]._source.id, responseFolder.data.assets[i]._source);
      }
    }

    yield put({ type: 'LOAD_FOLDERS', data: libraries, parent: responseFolder.data.parent });
    yield put({ type: 'LOAD_MAIN_FOLDERS', data: libraries, parent: responseFolder.data.parent });

    var responseFile = yield call(fetchUpload, getLib.libData, "file")
    if (responseFile.data.success) {
      for (let i = 0; i < responseFile.data.assets.length; i++) {
        libraries =  libraries.set(responseFile.data.assets[i]._source.id, responseFile.data.assets[i]._source);
      }
    }
    yield put({ type: 'LOAD_LIBRARY_COMPLETE', data: libraries, libType: getLib.libData.type });
  } catch (error) {
    let errObj = {
      err: error,
      respfolder: JSON.stringify(responseFolder),
      respFile: JSON.stringify(responseFile),
      request: JSON.stringify(getLib.libData) 
    }
    errorlog("loadLibraryUpload:  ",errObj, "Saga-loadLibraryUpload");
  }
}

export function* loadFolders(getLib) {
  try {
    var responseFolder = yield call(fetchUpload, { parent: getLib.libData.id, userId: getLib.libData.userId }, "folder")
    var libraries = {};
    if (responseFolder.data.success) {
      for (let i = 0; i < responseFolder.data.assets.length; i++) {
        libraries[responseFolder.data.assets[i]._source.id] = responseFolder.data.assets[i]._source;
      }
    }

    yield put({ type: 'LOAD_FOLDERS', data: libraries, parent: responseFolder.data.parent });
  } catch (error) {
    errorlog("Folders load in library failed " ,error, "Saga-loadFolders")
  }
}

export function* moveFolder(getLib) {
  try {
    var responseFolder = yield call(moveUserFolder, getLib.libData)

  } catch (error) {
    errorlog("Move folder failed " ,error, "Saga-moveFolder")
  }
}

export function* renameFolder(getLib) {
  try {
    var responseFolder = yield call(renameUserFolder, getLib.libData)

  } catch (error) {
    errorlog("Rename folder failed " ,error, "Saga-renameFolder")
  }
}

export function* fetchActions(getLib) {
  try {
    var response = yield call(fetchActionData, getLib.libData)
    var libraries = new Map();
    if (response.data.hits.length > 0) {
      for (let i = 0; i < response.data.hits.length; i++) {
        libraries.set(response.data.hits[i]._source.id, response.data.hits[i]._source);
      }
    }
    yield put({ type: 'LOAD_ACTIONS', data: libraries, total: response.data.total });

  } catch (error) {
    let errorObj = {
      error, 
      request: `${JSON.stringify(getLib)}`,
      response : `${JSON.stringify(response.data)}`
    }
    errorlog(`Characters action load failed fetchActions Request: `,errorObj, "Saga-fetchActions")
  }
}

export function* fetchSearch(getLib) {
  try {
    var response = {}, upResponse, otherRes, stockRes, gifRes, stockImgRes, isAlternateNeeded = false, dataCount = 0, typeToSearch = '', uploadSearch = 'AUDIO, VIDEO, IMG',action = 'uploaded',
    isStockImg = false, isStockVid = false, isGiphy = false, isUpload = false, others = false, prevType = getLib.libData.type;

    if(getLib.libData.type === 'PROP' || getLib.libData.type === 'BG'){
      response = yield call(fetchSearchData, getLib.libData);
      if(!getLib.libData.isExpanded){
        if(response.data.aggs && response.data.aggs.length){
          response.data.aggs.forEach((resObj) => {
            if(getLib.libData.type === 'PROP'){
              if(resObj.key === 'prop' || resObj.key === 'shape'){
                dataCount += resObj.doc_count;
              }
            }else{
              dataCount = resObj.doc_count;
            } 
            
            
          })
          if(dataCount <= 5){
            isAlternateNeeded = true;
          }else{
            if(getLib.libData.type === 'PROP'){
              response.data.aggs.forEach((objj) => {
                objj.doc_count = objj.key === 'prop' ?  dataCount : 0
              })
            }
          }
        }else if(response.data.aggs && !response.data.aggs.length){
          isAlternateNeeded = true;
        }
      }else{
        if(!response.data || ! response.data.hits || !response.data.hits.hits || !response.data.hits.hits.length){
          others = true;
          typeToSearch = 'PROP';
        }
      }
      
      if(isAlternateNeeded){
        if(getLib.libData.type === 'PROP'){
          isStockImg = true;
          isGiphy = true;
          isUpload = true;
        }else if(getLib.libData.type === 'BG'){
          isStockImg = true;
          isStockVid = true;
          isUpload = true;
        }
      }
    }else if(getLib.libData.type === 'AUDIO, VIDEO, IMG'){
        isUpload = true;
    }else if(getLib.libData.type === 'STOCKVID'){
        isStockVid = true;
    }else if(getLib.libData.type === 'STOCKIMG'){
        isStockImg = true;
    }else if(getLib.libData.type === 'GIPHY'){
        isGiphy = true;
    }

    if(isStockImg){
      stockImgRes = yield call(fetchStockImgData, getLib.libData);
      if(getLib.libData.type === 'STOCKIMG' && !getLib.libData.isExpanded && (!stockImgRes.data || !stockImgRes.data.aggs || !stockImgRes.data.aggs.length || stockImgRes.data.aggs[0].doc_count <= 5)){
        others = true;
        typeToSearch = 'PROP';
        isGiphy = true;
        isUpload = true;
      }
    }
    if(isStockVid){
      stockRes =  yield call(fetchStockVideos, getLib.libData);
      if(getLib.libData.type === 'STOCKVID' && !getLib.libData.isExpanded && (!stockRes.data || !stockRes.data.aggs || !stockRes.data.aggs.length || stockRes.data.aggs[0].doc_count <= 5)){
        stockImgRes = yield call(fetchStockImgData, getLib.libData);
        others = true;
        isUpload = true;
        typeToSearch = 'BG';
      }
    }
    if(isGiphy){
      gifRes = yield call(fetchGiphyData, getLib.libData);
      if(getLib.libData.type === 'GIPHY' && !getLib.libData.isExpanded && (!gifRes.data || !gifRes.data.aggs || !gifRes.data.aggs.length || gifRes.data.aggs[0].doc_count <= 5)){
        stockImgRes = yield call(fetchStockImgData, getLib.libData);
        others = true;
        typeToSearch = 'PROP';
        isUpload = true;
      }
    }
    if(others){
      if(typeToSearch) getLib.libData.type = typeToSearch
      otherRes = yield call(fetchSearchData, getLib.libData);
    }
    if(isUpload){
      if(uploadSearch) getLib.libData.type = uploadSearch;
      if(action) getLib.libData.action = action;
      upResponse = yield call(fetchSearchData, getLib.libData);
      if(upResponse.data.aggs && !upResponse.data.aggs.length){
        upResponse = {
          'data': {
            'aggs' : [{
                key : 'UPLOADS',
                doc_count : 0
            }]
          }
        }
      }
    }
    



    
    getLib.libData.type = prevType;
    
    var respAssets = new Map(), upResAssets = new Map(), otherResAssets = new Map(), vidResAssets = new Map(),
    imgResAssets = new Map(), gifResAssets = new Map();
    if (getLib.libData.type !== "STOCKIMG" && getLib.libData.type !== "STOCKVID") {
      if (response && response.data && response.data.hits && response.data.hits.hits && response.data.hits.hits.length > 0) {
        for (let i = 0; i < response.data.hits.hits.length; i++) {
          if(response.data.hits.hits[i]._source.brandinfo === 'GETTY-VIDEO'){
            let videoData = response.data.hits.hits[i]._source;
            let duration = parseFloat(videoData.clip_length.split(":")[0] * 3600) + parseFloat(videoData.clip_length.split(":")[1] * 60) + parseFloat(videoData.clip_length.split(":")[2])+"."+parseFloat(videoData.clip_length.split(":")[3]);
            videoData.duration = parseFloat(parseFloat(duration).toFixed(1));
            videoData.stockId = videoData.id;
            respAssets.set(videoData.id, videoData);
          }else if(response.data.hits.hits[i]._source.brandinfo === 'GETTY'){
            let imgData = response.data.hits.hits[i]._source;
            respAssets.set(imgData.id, { id: imgData.id, stockId: imgData.id, thumbnail: imgData.display_sizes[2].uri, src: imgData.display_sizes[0].uri, name: imgData.title, width: imgData.max_dimensions.width, height: imgData.max_dimensions.height, type: 'STOCKIMG', brandinfo: imgData.brandinfo, artist: imgData.artist, title: imgData.title, istock_collection : imgData.istock_collection, subType : imgData.subType, cost : imgData.cost});
          }else{
            respAssets.set(response.data.hits.hits[i]._source.id, response.data.hits.hits[i]._source);
          }
        }
      }

      if (upResponse && upResponse.data && upResponse.data.hits && upResponse.data.hits.hits && upResponse.data.hits.hits.length > 0) {
        for (let i = 0; i < upResponse.data.hits.hits.length; i++) {
          upResAssets.set(upResponse.data.hits.hits[i]._source.id, upResponse.data.hits.hits[i]._source);
        }
      }

      if (otherRes && otherRes.data && otherRes.data.hits && otherRes.data.hits.hits && otherRes.data.hits.hits.length > 0) {
        for (let i = 0; i < otherRes.data.hits.hits.length; i++) {
          otherResAssets.set(otherRes.data.hits.hits[i]._source.id, otherRes.data.hits.hits[i]._source);
        }
      }
    }

    if(stockRes){
      if(stockRes && stockRes.data.aggs && stockRes.data.aggs.length){
        if(Object.keys(response).length && response.data.aggs)
          response.data.aggs.push(stockRes.data.aggs[0])
        else if(response){
          response = {
            'data': {
              'aggs' : [stockRes.data.aggs[0]]
            }
          }
        }
      } 
      if(stockRes.data.hits && stockRes.data.hits.hits && stockRes.data.hits.hits.length > 0) {
        
        for (let i = 0; i < stockRes.data.hits.hits.length; i++) {
          let videoData = stockRes.data.hits.hits[i]._source;
          let duration = parseFloat(videoData.clip_length.split(":")[0] * 3600) + parseFloat(videoData.clip_length.split(":")[1] * 60) + parseFloat(videoData.clip_length.split(":")[2])+"."+parseFloat(videoData.clip_length.split(":")[3]);
          videoData.duration = parseFloat(parseFloat(duration).toFixed(1));
          videoData.stockId = videoData.id;
          vidResAssets.set(videoData.id, videoData);
        }
      }
    }

    if(stockImgRes){
      if(stockImgRes && stockImgRes.data && stockImgRes.data.aggs && stockImgRes.data.aggs.length){
        if(Object.keys(response).length && response.data.aggs)
          response.data.aggs.push(stockImgRes.data.aggs[0])
        else if(response){
          response = {
            'data': {
              'aggs' : [stockImgRes.data.aggs[0]]
            }
          }
        }
      } 
      if(stockImgRes.data && stockImgRes.data.hits && stockImgRes.data.hits.length > 0) {
        for (let i = 0; i < stockImgRes.data.hits.length; i++) {
          let imgData = stockImgRes.data.hits[i];
          imgResAssets.set(imgData.id, { id: imgData.id, stockId: imgData.id, thumbnail: imgData.display_sizes[2].uri, src: imgData.display_sizes[0].uri, name: imgData.title, width: imgData.max_dimensions.width, height: imgData.max_dimensions.height, type: imgData.type, artist: imgData.artist, title: imgData.title, istock_collection : imgData.istock_collection, subType : imgData.subType, cost : imgData.cost});
        }
      }
    }

    if(gifRes){
      if(gifRes && gifRes.data.aggs && gifRes.data.aggs.length){
        if(Object.keys(response).length && response.data.aggs){
          if(getLib.libData.type === 'GIPHY'){
            response.data.aggs.unshift(gifRes.data.aggs[0])
          }else
            response.data.aggs.push(gifRes.data.aggs[0])
        }
        else if(response){
          response = {
            'data': {
              'aggs' : [gifRes.data.aggs[0]]
            }
          }
        }
      }
      
      if(gifRes.data.hits && gifRes.data.hits.length > 0) {
        for (let i = 0; i < gifRes.data.hits.length; i++) {
          let gifData = gifRes.data.hits[i];
          gifResAssets.set(gifData.id, gifData)
        }
      }
    }

    let uploadsCount = 0;
    if(upResponse && upResponse.data && upResponse.data.aggs && upResponse.data.aggs.length){
      let isWentIn = false;
      for(let aggs = 0; aggs < upResponse.data.aggs.length; aggs++){
        let aggsObj = upResponse.data.aggs[aggs];
        if((aggsObj.key === 'img' || aggsObj.key === 'video' || aggsObj.key === 'audio')){

            let audioC = 0,
            videoC = 0,
            imgC = 0;
    
            if(aggsObj.key === 'audio'){
              audioC = aggsObj.doc_count
            }
            if(aggsObj.key === 'video'){
              videoC = aggsObj.doc_count
            }
            if(aggsObj.key === 'img'){
              imgC = aggsObj.doc_count
            }
            let overallCount = imgC + videoC + audioC
            uploadsCount += overallCount; 
            isWentIn = true;
        }
      }
      if(isWentIn)
        upResponse.data.aggs = [];
      if(uploadsCount){
        if(Object.keys(response).length){
          response.data.aggs.push({
            key : 'UPLOADS',
            doc_count : uploadsCount
          })
        }else{
          response = {
            'data': {
              'aggs' : [{
                  key : 'UPLOADS',
                  doc_count : uploadsCount
              }]
            }
          }
        }
      }
    }

    let overAllAggs = [];
    if(response && response.data && response.data.aggs && response.data.aggs.length){
      overAllAggs = overAllAggs.concat(response.data.aggs);

    }
    if(otherRes && otherRes.data && otherRes.data.aggs && otherRes.data.aggs.length){
      overAllAggs = overAllAggs.concat(otherRes.data.aggs);
    }
    if(upResponse && upResponse.data && upResponse.data.aggs && upResponse.data.aggs.length){
      overAllAggs = overAllAggs.concat(upResponse.data.aggs);
    }
      
    if(getLib.libData.type === 'AUDIO, VIDEO, IMG'){
      getLib.libData.type = 'UPLOADS';
    }

    if(getLib.libData.type === 'SCENEPRE'){
      getLib.libData.type = 'PREBUILT';
    }
    yield put({ type: 'LOAD_SEARCH_DATA', data: [
      {
        type : getLib.libData.type,
        data : respAssets
      },
      {
        type : 'UPLOADS',
        data : upResAssets
      },
      {
        type : (otherRes && otherRes.data && otherRes.data.aggs && otherRes.data.aggs.length) ? otherRes.data.aggs[0].key.toUpperCase() : getLib.libData.type,
        data : otherResAssets
      },
      {
        type : 'STOCKVID',
        data : vidResAssets
      },
      {
        type : 'STOCKIMG',
        data : imgResAssets
      },
      {
        type : 'GIPHY',
        data : gifResAssets
      },
    ], aggs: overAllAggs,isDefault: getLib.libData.isDefault, libType: getLib.libData.type, fromScroll: getLib.libData.fromScroll, tagValue: getLib.libData.tags });

  } catch (error) {
      errorlog(getLib.libData.type + " search in library failed fetchSearch " ,error, "Saga-fetchSearch")
  }
}

export function* fetchStockSearch(getLib) {
  try {
    var response = yield call(fetchStockSearchData, getLib.libData)
    var libraries = {};

    if (getLib.libData.type === "STOCKIMG" && response.data.hits.length > 0) {
      for (let i = 0; i < response.data.hits.length; i++) {
        let imgData = response.data.hits[i];
        libraries[imgData.id] = { stockId: imgData.id, thumbnail: imgData.display_sizes[2].uri, src: imgData.display_sizes[0].uri, name: imgData.title, width: imgData.max_dimensions.width, height: imgData.max_dimensions.height, type: getLib.libData.type };
      }
    }
    else if (getLib.libData.type === "STOCKVID" && response.data.hits.length > 0) {
      for (let i = 0; i < response.data.hits.length; i++) {
        let videoData = response.data.hits[i];
        if(videoData.clip_length){
        var duration = videoData.clip_length.split(":")[0] * 3600 + videoData.clip_length.split(":")[1] * 60 + videoData.clip_length.split(":")[2]
        libraries[videoData.id] = { stockId: videoData.id, thumbnail: videoData.display_sizes[3].uri, src: videoData.display_sizes[0].uri, name: videoData.title, poster: videoData.display_sizes[1].uri, type: getLib.libData.type, duration: parseInt(duration) };
      }
    }
    }
    yield put({ type: 'LOAD_SEARCH_DATA', data: libraries, total: response.data.hits.total, aggs: response.data.aggs, libType: getLib.libData.type, fromScroll: getLib.libData.fromScroll });

  } catch (error) {
    errorlog(getLib.libData.type + " stock search in library failed fetchStockSearch " ,error, "Saga-fetchStockSearch")
  }
}

export function* fetchActionSearch(getLib) {
  try {

    var response = yield call(fetchSearchData, getLib.libData);
    
    var libraries = new Map();
    if (response.data.hits.total > 0) {
      
      for (let i = 0; i < response.data.hits.hits.length; i++) {
        
        libraries.set(response.data.hits.hits[i]._source.id, response.data.hits.hits[i]._source);
      }
      
      
    }


    yield put({ type: 'LOAD_ACTIONSEARCH_DATA', data: libraries, total: response.data.hits.total });

 

  } catch (error) {
    errorlog(getLib.libData.type + " search in library failed fetchSearch " ,error, "Saga-fetchActionSearch")
  }
}

export function* loadLibrary(getLib) {
  try {
    var libraries = new Map(), response, total = 0, libProp={}, brandRes, brandPreResp;
    if (getLib.libData.type !== "STOCKVID") {
      response = yield call(fetchCategory, getLib.libData);
      brandRes = response.data.brand;


      if(brandRes && brandRes.length && !getLib.libData.from){
        let dataArr = [], category = 'Animaker';
        for(let br=0; br<brandRes.length; br++){
          dataArr.push(brandRes[br]._source);
        }
        if(getLib.libData.type === 'MASPROP'){
          category = 'Brand Logos';
        }else if(getLib.libData.type === 'MASCHR'){
          category = 'Brand Character';
        }else if(getLib.libData.type === 'MASBG'){
          category = 'Brand Video';
        }else if(getLib.libData.type === 'MASSCENEPRE'){
          category = 'Brand Prebuilt';
        }
        let _source = {
          category,
          catorder: "1",
          type: getLib.libData.type,
          data: dataArr
        }
        total = response.data.total + 1;
        if(response.data.hits){
          response.data.hits.unshift({ _source });
        }else{
          let hits = [{_source}];
          response.data['hits'] = hits;
        }
        
      }else{
        if(getLib.libData.loadBrand && getLib.libData.from){
          if(response.data.total)
            total = response.data.total + 1;
        }else{
          total = response.data.total;
        }
      }
      
        if(getLib.libData.type === 'MASPROP' || getLib.libData.type === 'MASSTOCKIMG' || getLib.libData.type === 'MASBG' || getLib.libData.type === 'MASCHR' || getLib.libData.type === 'MASGIPHY' || getLib.libData.type === 'MASSTOCKVID' || getLib.libData.type === 'MASSCENEPRE' || getLib.libData.type === 'MASSM' || getLib.libData.type === 'MASBPROP'){
          if(getLib.libData.type === 'MASSTOCKIMG' || getLib.libData.type === 'MASSTOCKVID'){
            if(getLib.libData.exclusive)
              libraries.set('Top Exclusive', {
                'items' : []
              })
          }
            for (let i = 0; i < response.data.hits.length; i++) {
              if(getLib.libData.type === 'MASSTOCKIMG' || getLib.libData.type === 'MASSTOCKVID'){
                let stockVidData = response.data.hits[i]._source.data;
                if(getLib.libData.type === 'MASSTOCKVID'){
                  for(let j=0; j<stockVidData.length; j++){
                    let videoData = stockVidData[j];
                    let duration = videoData.clip_length.split(":")[0] * 3600 + videoData.clip_length.split(":")[1] * 60 + videoData.clip_length.split(":")[2]+"."+videoData.clip_length.split(":")[3];
                    videoData.duration = parseFloat(parseFloat(duration).toFixed(1));
                    stockVidData[j] = videoData;
                  }
                }
                let catName = response.data.hits[i]._source.category;
                if(response.data.hits[i]._source[`category_${getLib.libData.lang}`]){
                  catName = response.data.hits[i]._source[`category_${getLib.libData.lang}`];
                }
                libraries.set(catName, {
                  'items' : stockVidData,
                  'searchtag' : response.data.hits[i]._source.searchtag
                })
              }else{
                let resultedData = [], searchTag = '';
                if(getLib.libData.type === 'MASBG' && response.data.hits[i]._source.category === 'GETTY'){
                  let bgData = response.data.hits[i]._source.data;
                  for(let idx=0; idx<bgData.length; idx++){
                    let imgData = bgData[idx];
                    searchTag = response.data.hits[i]._source.searchTag;
                    resultedData.push({ id: imgData.id, thumbnail: imgData.display_sizes[2].uri, src: imgData.display_sizes[0].uri, name: imgData.title, width: imgData.max_dimensions.width, height: imgData.max_dimensions.height, type: 'STOCKIMG', brandinfo: imgData.brandinfo, artist: imgData.artist, title: imgData.title, stockId: imgData.stockid, istock_collection : imgData.istock_collection, subType : imgData.subType, cost : imgData.cost, category: imgData.category, plan: imgData.plan});
                  }
                }else if(getLib.libData.type === 'MASBG' && (response.data.hits[i]._source.category === 'GETTY VIDEO' || response.data.hits[i]._source.category === 'Video Backgrounds')){
                  let videoDataArr = response.data.hits[i]._source.data;
                  searchTag = response.data.hits[i]._source.searchTag;
                  for(let k=0; k<videoDataArr.length; k++){
                    let videoData = videoDataArr[k];
                    if(response.data.hits[i]._source.category !== 'Video Backgrounds'){
                      let duration = videoData.clip_length.split(":")[0] * 3600 + videoData.clip_length.split(":")[1] * 60 + videoData.clip_length.split(":")[2]+"."+videoData.clip_length.split(":")[3];
                      videoData.duration = parseFloat(parseFloat(duration).toFixed(1));
                    }
                    resultedData.push(videoData);
                  }
                  
                }else{
                  resultedData = response.data.hits[i]._source.data
                }
                let catName = response.data.hits[i]._source.category;
                if(response.data.hits[i]._source[`category_${getLib.libData.lang}`]){
                  catName = response.data.hits[i]._source[`category_${getLib.libData.lang}`];
                }
                libraries.set(catName, {
                  'items' : resultedData,
                  'searchtag' : searchTag
                })
              }
            }
          libProp= {
            'data' : libraries,
            'total' : total
          }
        }else{
          for (let i = 0; i < response.data.hits.length; i++) {
            libraries.set(response.data.hits[i]._source.id, response.data.hits[i]._source);
          }
        }
      }
    let libType = getLib.libData.type;
    if(getLib.libData.type === 'MASPROP') libType = 'PROP'; 
    else if(getLib.libData.type === 'MASBG') libType = 'BG';
    else if(getLib.libData.type === 'MASGIPHY') libType = 'GIPHY';
    else if(getLib.libData.type === "MASSCENEPRE") libType = "PREBUILT";
    else if(getLib.libData.type === "MASSM") libType = "SM";
    else if(getLib.libData.type === 'MASCHR') libType = 'CHR';
    else if(getLib.libData.type === 'MASSTOCKIMG') libType = 'STOCKIMG';
    else if(getLib.libData.type === 'MASSTOCKVID') libType = 'STOCKVID';

    if(!libraries.size){
      yield put({ type: 'RESP_UPDATE', data: {
          status : 'failed',
        }
      })
    }
    
    yield put({ type: 'LOAD_LIBRARY_COMPLETE', lang: getLib.libData.lang, data: (getLib.libData.type !== 'MASPROP' && getLib.libData.type !== 'MASSTOCKVID' && getLib.libData.type !== 'MASSTOCKIMG' && getLib.libData.type !== 'MASBG' && getLib.libData.type !== 'MASGIPHY' && getLib.libData.type !== 'MASCHR' && getLib.libData.type !== 'MASSCENEPRE' && getLib.libData.type !== 'MASSM') ? libraries : libProp, libType: libType, subType: getLib.libData.subType, total: total });
  } catch (error) {
    let errorObj = {
      error, 
      request: `${JSON.stringify(getLib.libData)}`,
      response : `${JSON.stringify(response)}`
    }
    errorlog(" Error in loadLibrary " ,errorObj, "Saga-loadLibrary");
  }
}

export function* loadCategoryLibrary(getLib) {
  try {
    var libraries = new Map(), response, total = 0, brandRes, brandTxtObj = {};
      response = yield call(fetchCategory, getLib.libData);
      if(getLib.libData.type === 'TEXT' && getLib.libData.loadBrand && !getLib.libData.from){
        brandRes = yield call(fetchBrandData, getLib.libData);
        for(let bt=0; bt<brandRes.data.hits.length; bt++){
          brandTxtObj[bt] = brandRes.data.hits[bt]._source;
        }
      }
      total = response.data.total;      
      if ((response.data.hits.length > 0 || (response.data.hits.hits && response.data.hits.hits.length > 0))) {
        if(getLib.libData.type === 'STOCKIMG'){
          for (let i = 0; i < response.data.hits.length; i++) {
            let imgData = response.data.hits[i]
            libraries.set(response.data.hits[i].id, { id: imgData.id, thumbnail: imgData.display_sizes[2].uri, src: imgData.display_sizes[0].uri, name: imgData.title, width: imgData.max_dimensions.width, height: imgData.max_dimensions.height, type: getLib.libData.type, artist: imgData.artist, title: imgData.title, stockId: imgData.id, istock_collection : imgData.istock_collection, subType : imgData.subType, cost : imgData.cost});
          }
        }else{
          if(getLib.libData.type === 'STOCKVID'){
            total = response.data.hits.total;
            for (let i = 0; i < response.data.hits.hits.length; i++) {
                let videoData = response.data.hits.hits[i]._source;
                let duration = videoData.clip_length.split(":")[0] * 3600 + videoData.clip_length.split(":")[1] * 60 + videoData.clip_length.split(":")[2]+"."+videoData.clip_length.split(":")[3];
                videoData.duration = parseFloat(parseFloat(duration).toFixed(1));
                libraries.set(videoData.id, videoData);
            }
          }else{
            for (let i = 0; i < response.data.hits.length; i++) {
              let resultedData;
              if(response.data.hits[i]._source.brandinfo === 'GETTY'){
                let imgData = response.data.hits[i]._source;
                resultedData = { id: imgData.id, thumbnail: imgData.display_sizes[2].uri, src: imgData.display_sizes[0].uri, name: imgData.title, width: imgData.max_dimensions.width, height: imgData.max_dimensions.height, type: 'STOCKIMG', brandinfo: imgData.brandinfo, artist: imgData.artist, title: imgData.title, stockId: imgData.stockid, istock_collection : imgData.istock_collection, subType : imgData.subType, cost : imgData.cost, category: imgData.category, plan: imgData.plan};
              }else if(response.data.hits[i]._source.brandinfo === 'GETTY-VIDEO' || response.data.hits[i]._source.subtype === 'OBGVID'){
                let videoData = response.data.hits[i]._source;
                if(response.data.hits[i]._source.subtype !== 'OBGVID'){
                  let duration = videoData.clip_length.split(":")[0] * 3600 + videoData.clip_length.split(":")[1] * 60 + videoData.clip_length.split(":")[2]+"."+videoData.clip_length.split(":")[3];
                  videoData.duration = parseFloat(parseFloat(duration).toFixed(1));
                }
                resultedData = videoData;
              }else{
                resultedData = response.data.hits[i]._source;
              }
              libraries.set(response.data.hits[i]._source.id, resultedData);
            }
          }
        }
      }

      else{
        if(getLib.libData.type === 'STOCKIMG'){
          yield put({ type: 'LOAD_COMPLETE', loadComplete:true});
        }
      }
    if (!getLib.libData.fromSearch && libraries.size){
      yield put({ type: 'LOAD_CATEGORY_COMPLETE', lang: getLib.libData.lang, data: libraries, libData: getLib.libData, total: total, brandData:  brandTxtObj});
      if (getLib.libData.type === 'BG'){
        yield put({ type: 'BG_CATEGORY_LOAD', bgCategoryLoad:true});
      }
    }
    else if(libraries.size)
      yield put({ type: 'LOAD_SEARCH_DATA', data: libraries, total: total, libType: getLib.libData.type, fromScroll: getLib.libData.fromScroll });
  } catch (error) {
    let errorObj = {
      error, 
      request: `${JSON.stringify(getLib.libData)}`,
      response : `${JSON.stringify(response)}`
    }
    errorlog(" library failed loadCategoryLibrary " ,errorObj, "Saga-loadCategoryLibrary")
  }
}


export function* batchActions(data) {
  try {
    for (var a = 0; a < data.actions.length; a++) {
      yield put(data.actions[a]);
    }
  } catch (error) {
    errorlog("batchActions failed " ,error, "Saga-batchActions")
  }
}

function fetchBrandData(reqData){
  let url = `${config["APIURIS"][environment]}brand/gb`,
  data = new URLSearchParams();
  data.append('u', reqData.userId);
  data.append('t', reqData.teamId);
  data.append('ty', reqData.brandType);
  return axios({
    method: 'post',
    url,
    headers: { "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
    data
  });
}

function saveThumbnail(postState) {
    let url = config["APIURIS"][environment] + "app/svest";
    const params = new URLSearchParams();
    params.append('userId', postState.userId);
    params.append('projectId', postState.projectId);
    params.append('project', postState.project);
    let screenshots = {};
    params.append('screenshots', JSON.stringify(screenshots));
    
    return axios({
      method: 'post',
      url: url,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', "X-CSRFToken": csrftoken, "Authorization" : encodetoken },
      data: params
    }).then(function (response) {
      return response;
    }).catch(function (error) {
      return "error";
    });
}

export function* saveSceneThumb(postState){
  const result = yield call(saveThumbnail, postState);
}

export function* watchLoadProject(data) {
  yield all([watchProjectLoader(data), watchLibraryLoader(), watchCreateLibraryFolder(), watchDeleteUserContent()])
}

export function* watchLibraryLoader() {
  yield takeLatest("LOAD_LIBRARY", loadLibrary);
  yield takeLatest("LOAD_LIBRARY_MASTER", loadMasterLibrary);
  yield takeLatest("LOAD_LIBRARY_CATEGORY", loadCategoryLibrary);
  yield takeLatest("LOAD_LIBRARY_UPLOAD", loadLibraryUpload);
  yield takeLatest("LOAD_USER_FOLDERS", loadFolders);
  yield takeLatest("MOVE_FILE_LOCATION", moveFolder);
  yield takeLatest("RENAME_USER_FILE", renameFolder);
  yield takeLatest("GET_ACTIONS", fetchActions);
  yield takeLatest("FETCH_SEARCH", fetchSearch);
  yield takeLatest("FETCH_STOCK_SEARCH", fetchStockSearch);
  yield takeLatest("FETCH_ACTION_SEARCH", fetchActionSearch);
  yield takeLatest("BATCH_ACTIONS", batchActions);
  yield takeLatest("EXPORT_PROJECT", onExportProject);
  yield takeLatest("SHARE_PROJECT", onShareProject);
  yield takeLatest("PROJECT_RESIZE", onProjectResize);
  yield takeLatest("DUPLICATE_PROJECT", onProjectDuplicate);
  yield takeLatest("LOAD_SHARE_DETAILS", loadShareDetails);
  yield takeLatest("SAVE_SCREENSHOT", saveSceneThumb);
}

export function* watchCreateLibraryFolder() {
  yield takeLatest("CREATE_LIBRARY_FOLDER", createLibraryFolder);
}

export function* watchDeleteUserContent() {
  yield takeLatest("DELETE_FILE", deleteFiles);
}

export function* startProjectLoad(data) {
  try {

    

  } catch (error) {
    console.log("error", error);
  }
}

export function* loadUserFonts(data) {
  try {
   
    var userFonts = yield call(fetchUserFonts, data);
   
    let uploadedFonts = [];
    if(userFonts.data.success && (userFonts.data.assets.length > 0 || userFonts.data.BRAND.length)){
      for(var i = 0; i < userFonts.data.assets.length; i++){
        uploadedFonts.push(userFonts.data.assets[i]._source);
      }
      for(var i = 0; i < userFonts.data.BRAND.length; i++){
        uploadedFonts.push(userFonts.data.BRAND[i]._source);
      }
    }

    uploadedFonts.sort(function(a,b){
      return new Date(a.created) - new Date(b.created);
    });
   
    yield put({ type: "SET_USER_FONTS", data: uploadedFonts });
    
  } catch (error) {
    errorlog("error", error, "Saga-loadUserFonts");
  }
}

export function* loadShareDetails(data) {
  try {
  
    var shareDetails = yield call(fetchShareDetails, data);
    
    yield put({ type: "SET_SHARE_DETAILS", data: shareDetails.data });
    
  } catch (error) {
    errorlog("error", error, "Saga-loadShareDetails`");
  }
}

export function* setUserDetails(data) {
  try {
   
    const userDetails = yield call(fetchUserDetails, data.data);
    
    yield put({ type: "UPDATE_USER_DETAILS", data: userDetails.data });
    
  } catch (error) {
    errorlog("error", error, "Saga-setUserDetails");
  }
}

export function* watchProjectLoader(data) {
  try {
    const userDetails = yield call(fetchUserDetails, data);
    yield put({ type: "UPDATE_USER_DETAILS", data: userDetails.data });
    data['bf'] = userDetails.data.bf;
    yield call(loadUserFonts, data);

    const effectData = yield call(fetchEffects, data);
    yield put({ type: 'LOAD_LIBRARY_COMPLETE', data: effectData.data, libType: 'EFFECTS' });
    yield put({ type: 'APP_LOAD_PROGRESS', data: 20 });

    // if(data.mode !== 'slide'){
    // const autoSearchData = yield call(fetchAutoSearch, {data});
    // yield put({ type: 'LOAD_AUTOSEARCH', data: autoSearchData.data});
    // }
    
    let themesData;
    if(userDetails.data.bf)
      themesData = yield call(getColorThemes, {hasBrand : 1, data});
    else
      themesData = yield call(getColorThemes, {hasBrand : 0, data});

    if(themesData.data.brand){
      let tBDataArr = themesData.data.brand.colorpalette, tBData = {},
      tempObj = themesData.data.colorPalettes;
      let pri = {}, sec = {};
      tBDataArr.forEach(val => {
        val.isDefault = true;
        val.isBrand = true;
        let bKey = uuid();
        if(val.primary){
          pri[bKey] = val;
        }else{
          sec[bKey] = val;
        }
      })
      if(Object.keys(pri).length){
        tBData = {...pri, ...sec};
      }else{
        tBData = sec;
      }
      themesData.data.colorPalettes = {...tBData, ...tempObj};
    }
    yield put({ type: 'LOAD_COLOR_THEMES', data: themesData.data});
   
    yield put({ type: 'APP_LOAD_PROGRESS', data: 20 });
    yield put({ type: 'LOAD_LIBRARY_COMPLETE', data: themesData.data, libType: 'COLOR_THEMES' });
    yield put({ type: 'APP_LOAD_PROGRESS', data: 20 });
   
    const transitionData = yield call(fetchTransition, data);
    yield put({ type: 'LOAD_LIBRARY_COMPLETE', data: transitionData.data, libType: 'TRANS' });
    yield put({ type: 'APP_LOAD_PROGRESS', data: 20 });

  
  } catch (error) {
    errorlog("Project load failed " ,error, "Saga-watchProjectLoader")
  }
}


// WEBPACK FOOTER //
// ./src/sagas/index.js